import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ExamplePanel from '../Helpers/ExamplePanel';
import Footer from '../Helpers/Footer';
import Sidebar from '../Helpers/Sidebar';
import Toolbar from '../Helpers/Toolbar';
import { connect } from 'react-redux';
import { generalActions } from '../../actions/general.action';
import { configureActions } from '../../actions/configure.action';
import { bindActionCreators } from 'redux';
import Navigation from '../Helpers/Navigation';
import routes from '../../routes/routes';
import Shortcut from '../UI/Shortcut';
import { useHistory } from 'react-router';
import { matchPath, withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function LayoutMobile(props) {
  const history = useHistory();
  const closeExamplePanel = () => {
    document.body.classList.remove('content-side-open');
  };
  const closeNav = () => {
    document.body.classList.remove('content-side-nav-open');
  };
  function findTitle() {
    for (let route of routes) {
      if (matchPath(props.location.pathname, route)) {
        return props.t(route.title);
      }
    }

    return null;
  }
  function onClickBack() {
    if (props.noBack) {
      props.onBack();
    } else {
      history.goBack();
    }
  }
  return (
    <div className="page-inner">
      {/* <Toolbar /> */}
      {/* <Sidebar /> */}

      <div className="content-side-nav-wrapper">
        <div className="content-side-nav-overlay" onClick={closeNav} />
        <div className="content-side-nav">{/* <Navigation /> */}</div>
      </div>

      <div className="main">
        <div className="page-title d-flex justify-content-between align-items-center">
          {/* <NavigationMobileShortcut /> */}
          <div className="d-flex">
            {props.noBack ? null : (
              <div
                onClick={onClickBack}
                className="d-flex align-items-center mr-10"
              >
                <i className="md-icon">arrow_back</i>
              </div>
            )}
            <h1>{props.title || findTitle()}</h1>
          </div>
          <Shortcut />
        </div>

        <div className="content">{props.children}</div>

        <Footer />
      </div>

      <div className="content-side-wrapper">
        <div className="content-side-overlay" onClick={closeExamplePanel} />
        <div className="content-side">
          <ExamplePanel />
        </div>
      </div>
    </div>
  );
}

LayoutMobile.propTypes = {
  children: PropTypes.node.isRequired,
};

function mapStateToProps(state) {
  return {
    general: state.general,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withTranslation('app')(LayoutMobile)));
